export function modifyPaths(
  paths: { [key: string]: string },
  modifier: (path: string) => string
) {
  Object.entries(paths || {}).forEach(([lang, path]) => {
    paths[lang] = modifier(path);
  });
  return paths;
}
